// ======================================================================
// File Name       : ServiceRecordContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { reduxForm, change } from 'redux-form';
import ServiceRecordSearch from '../../components/service/serviceRecord/ServiceRecordSearch';
import ServiceRecordList from '../../components/service/serviceRecord/ServiceRecordList';
import ServiceRecordMaxInfo from '../../components/service/serviceRecord/ServiceRecordMaxInfo';
import ServiceListDialog from '../../components/service/serviceRecord/ServiceListDialog';
import ServiceGroupDialog from '../../components/service/serviceRecord/ServiceGroupDialog';
import * as ServiceRecordAction from '../../actions/serviceRecord/ServiceRecordAction';
import * as Path from '../../constants/PathConstants';
import { getPath, getServiceUsageListForServiceList, getSystemUsageMonth, now } from '../../utils/ServiceRecordUtils';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM, LO_SUPER_USER, SUPER_USER, DEFAULT_YEAR_MONTH } from '../../constants/index';
import ModalConductor from '../../components/modal/ModalConductor';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import { PRICE_PLAN } from '../../constants/EnterpriseConstants';
import { DISPLAY_USER_TYPE } from '../../constants/UserConstants';
import { isObject } from '../../utils/ApiUtils';

class ServiceRecordContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInfo: {
        selectTargetMonth: '',
        serviceCdList: [],
        startPosition: 0,
      },
      serviceUsageList: [],
      enterpriseUsageList: [],
      recordNum: 0,
      showDialog: false,
      showGroupSelectDialog: false,
      isAllowShowSearchMessage: false,
      isAllowShowSearchMessageInServiceDialog:false,
      isInit: false,
    };
    this.pathOptions = {
      apiPath: '',
      drillServer: false,
      isCompany: true,
      isServiceList: false,
      url: '',
    };
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSearchBtnClick = this.handleSearchBtnClick.bind(this);
    this.getRecordList = this.getRecordList.bind(this);
    this.onClickOpenDialog = this.onClickOpenDialog.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.onSelectGroup = this.onSelectGroup.bind(this);
    this.openGroupSelectDialog = this.openGroupSelectDialog.bind(this);
    this.downloadFormOK = this.downloadFormOK.bind(this);
    this.onSelectedService = this.onSelectedService.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.cancelSelectedService = this.cancelSelectedService.bind(this);
    this.onCSVExportOk = this.onCSVExportOk.bind(this);
    this.onCSVExportCancel = this.onCSVExportCancel.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
  }

  componentWillMount() {
    const path = getPath(this.props.match.url);
    this.pathOptions = {
      ...this.pathOptions,
      apiPath: path.apiPath,
      drillServer: path.drillServer,
      isCompany: path.isCompany,
      isServiceList: path.isServiceList,
      url: this.props.match.url,
    };
    this.setState({ isInit: true });
    if (
      !this.props.serviceRecord ||
      !this.props.serviceRecord.systemUsageMonths ||
      this.props.serviceRecord.systemUsageMonths[0] !== now.format(DEFAULT_YEAR_MONTH)
    ) {
      const systemUsageMonths = getSystemUsageMonth();
      this.props.dispatch(
        ServiceRecordAction.saveSystemUsageMonths(systemUsageMonths, this.getRecordList),
      );
      if (path.isServiceList) {
        this.props.change('startPosition', null);
        this.props.dispatch(ServiceRecordAction.getServiceList(this.createParamsGetServiceList(0)));
      }
    } else {
      this.getRecordList();
    }
  }

  componentWillUnmount() {
    this.props.dispatch(ServiceRecordAction.reInitializeForm(null, null));
  }

  componentWillReceiveProps(nextProps) {
    const {
      match: { url },
    } = this.props;
    const { searchResult, serviceInfo, enterprises } = nextProps;
    const targetSearchResult = searchResult?.[url];

    this.setState({
      ...this.state,
      serviceUsageList: targetSearchResult?.serviceUsageList,
      enterpriseUsageList: targetSearchResult?.enterpriseUsageList,
      recordNum: serviceInfo.recordNum,
      enterprises,
    });
  }

  getRecordList() {
    let params = {};
    if (this.props.serviceRecordSearch && this.props.serviceRecordSearch.values) {
      const { values } = this.props.serviceRecordSearch;
      params = this.createSearchParams(
        this.pathOptions,
        values.selectedService,
        values.selectedEnterprise,
        SELECT_TARGET_DATA.DATA,
        values.selectTargetMonth,
      );
    } else {
      params = this.createSearchParams(
        this.pathOptions,
        this.props.authedUser.serviceCd,
        this.props.authedUser.enterpriseCd,
        SELECT_TARGET_DATA.DATA,
        now.format(DEFAULT_YEAR_MONTH),
      );
    }
    if (!params) {
      return;
    }
    this.setState(
      {
        isAllowShowSearchMessage: false,
      },
      () => {
        this.props.dispatch(ServiceRecordAction.getRecordList(params, this.pathOptions)).then(
        () => {
          if (!this.state.isInit) {
            this.setState({ isAllowShowSearchMessage: true });
          }
        });
      },
    );
  }

  downloadFormOK() {
    let paramDL = {};
    if (this.props.serviceRecordSearch && this.props.serviceRecordSearch.values) {
      const { values } = this.props.serviceRecordSearch;
      paramDL = this.createSearchParams(
        this.pathOptions,
        values.selectedService,
        values.selectedEnterprise,
        SELECT_TARGET_DATA.CSV,
        values.selectTargetMonth,
      );
    } else {
      paramDL = this.createSearchParams(
        this.pathOptions,
        this.props.authedUser.serviceCd,
        this.props.authedUser.enterpriseCd,
        SELECT_TARGET_DATA.CSV,
        now.format(DEFAULT_YEAR_MONTH),
      );
    }
    if (!paramDL) {
      return;
    }
    this.props.dispatch(ServiceRecordAction.getRecordList(paramDL, this.pathOptions));
  }

  createSearchParams(pathOptions, serviceCd, enterpriseCd, selectTargetData, selectTargetMonth) {
    const params = {};
    const searchInfo = {};
    if (!this.pathOptions.isCompany) {
      if (!serviceCd) {
        return null;
      }
      if (!this.pathOptions.isServiceList) {
        searchInfo.serviceCdList = [];
        serviceCd && searchInfo.serviceCdList.push(serviceCd);
      }
    } else {
      searchInfo.enterpriseCdList = [];
      enterpriseCd && searchInfo.enterpriseCdList.push(enterpriseCd);
    }
    selectTargetMonth &&
      (searchInfo.selectTargetMonth = selectTargetMonth.replace('/', ''));
    params.enterpriseId = this.props.authedUser.enterpriseId;
    params.selectTargetData = selectTargetData;
    params.searchInfo = searchInfo;
    return params;
  }

  handleSearchBtnClick() {
    this.setState({ isInit: false }, () => {
      this.props.change('startPosition', null);
      if (this.pathOptions.isServiceList) {
        this.handleSearchBtn();
      }
      this.getRecordList();
    });
  }

  // #7116 START
  handleSearchBtn() {
    this.setState(
      {
        isAllowShowSearchMessageInServiceDialog: false,
        isInit:false,
      },
      () => {
        this.props.dispatch(ServiceRecordAction.getServiceList(this.createParamsGetServiceList(0))).then(
        () => {
          if (!this.state.isInit) {
            this.setState({ isAllowShowSearchMessageInServiceDialog: true });
          }
        });
      },
    );
  }
  // #7116 END
 
 createParamsGetServiceList(startPosition) {
    const { authedUser, serviceRecordSearch } = this.props;
    const serviceTypes = [0, 2];
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        ascendingDescendingSort: this.state.ascendingDescendingSort,
        serviceTypeList: serviceTypes,
        startPosition,
        returnMaxNum: RETURN_MAX_NUM,
      },
    };
    // #7116 START
    if (serviceRecordSearch && serviceRecordSearch.values) {
      const { dialogServiceCd, dialogServiceName} = serviceRecordSearch.values;
      param.searchInfo.serviceCdList = dialogServiceCd ? [dialogServiceCd] : [];
      param.searchInfo.serviceName = dialogServiceName;
    }
    // #7116 END
    param.enterpriseId = this.props.authedUser.enterpriseId;
    param.institutionId = this.props.authedUser.institutionId;
    const displayUserType = this.props.authedUser.userInfo.displayUserType;
    const superUser = [LO_SUPER_USER, SUPER_USER].indexOf(displayUserType) > -1;
    if (!superUser) {
      param.searchInfo.serviceCdList = [this.props.authedUser.serviceCd];
    }
    return param;
  }

  getStartEndData(startPosition) {
    const { isServiceList } = this.pathOptions;
    this.setState(
      {
        searchInfo: { ...this.state.searchInfo, startPosition },
        isInit: false,
      },
      () => {
        const params = this.createParamsGetServiceList(startPosition);
        this.props.dispatch(ServiceRecordAction.getServiceList(params, null, null));
      },
    );
  }

  onClickOpenDialog() {
    if (!this.pathOptions.isCompany) {
      const params = this.createParamsGetServiceList(0);
      this.props.dispatch(ServiceRecordAction.getServiceList(params)).then(() => {
        this.openDialog();
      });
    } else {
      this.openGroupSelectDialog();
    }
  }

  openDialog() {
    const searchInfo = { ...this.state.searchInfo };
    searchInfo.startPosition = 0;
    this.setState({
      showDialog: true,
      searchInfo,
    });
  }

  closeDialog() {
    this.setState({
      showDialog: false,
    });
  }

  cancelSelectedService() {
    // this.closeDialog();
    this.setState({
      showDialog: false,
    }, () => {
      this.props.reset();
    });
  }

  onSelectedService(newService) {
    const { enterpriseCd } = this.props.serviceRecordSearch.values;
    this.setState({
      showDialog: false,
    }, () => {
      this.props.dispatch(ServiceRecordAction.reInitializeForm(enterpriseCd, newService));
    });
  }

  openGroupSelectDialog() {
    this.setState(prevState => ({
      showGroupSelectDialog: !prevState.showGroupSelectDialog,
    }));
  }

  onSelectGroup(data) {
    const { serviceCd } = this.props.serviceRecordSearch.values;
    this.props.dispatch(ServiceRecordAction.reInitializeForm(data, serviceCd));
  }

  /**
   * Open dialog confirm export CSV file
   */
  openCSVExportConfirm(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  onCSVExportCancel() {
    this.setState({ showModal: false });
  }

  onCSVExportOk() {
    this.setState({ showModal: false });
    this.downloadFormOK();
  }

  // #7116 START
  dismissMessage() {
    this.setState({ 
      isAllowShowSearchMessage: false,
      isAllowShowSearchMessageInServiceDialog: false,
    });
  }
  // #7116 END

  render() {
    const { showDialog, showGroupSelectDialog } = this.state;
    const { reset, systemUsageMonths, initialValues, enterprises, authedUser, serviceInfo } = this.props;
    const { displayUserType } = authedUser.userInfo;
    const { serviceCd, enterpriseCdForDisplay } = initialValues;
    let serviceUsageList = this.pathOptions.isCompany ?
    this.state.enterpriseUsageList : this.state.serviceUsageList;

    const isSupperUserL0 = [LO_SUPER_USER].indexOf(displayUserType) > -1;
    let isUsingNewPlan = false;
    let generalPurposeNumber;
    if (!isSupperUserL0) {
      let pricePlan;
      // #7096 START
      if (DISPLAY_USER_TYPE.ADMIN === displayUserType) { // In case of admin
        pricePlan = authedUser.parentEnterprisePricePlan;
      } else {
        pricePlan = enterprises && Object.keys(enterprises.bySecernId).length &&
        enterprises.bySecernId[authedUser.enterpriseCd].usageSettingInfo &&
        enterprises.bySecernId[authedUser.enterpriseCd].usageSettingInfo.pricePlan;
      }
      pricePlan = pricePlan === undefined ? PRICE_PLAN.OLD : pricePlan;
      // #7096 END
      isUsingNewPlan = pricePlan === PRICE_PLAN.NEW;
    }
    // #7116 START
    generalPurposeNumber = enterpriseCdForDisplay && enterprises && Object.keys(enterprises.bySecernId).length &&
    enterprises.bySecernId[enterpriseCdForDisplay].generalPurposeNumber;
    // #7116 END
    return (
      <div>
        <MessageSearch
          recordNum={serviceUsageList ? serviceUsageList.length : 0}
          resultList={serviceUsageList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <ServiceRecordSearch
          recordNum={this.state.recordNum}
          getStartEndData={this.getStartEndData}
          onSearchBtnClick={this.handleSearchBtnClick}
          authedUser={this.props.authedUser}
          isCompany={this.pathOptions.isCompany}
          openDialog={this.onClickOpenDialog}
          systemUsageMonths={systemUsageMonths}
          serviceCd={serviceCd}
          // #7116 START
          enterpriseCdForDisplay={enterpriseCdForDisplay}
          generalPurposeNumber={generalPurposeNumber}
          isSupperUserL0 = {isSupperUserL0}
           canAccessOneService={this.props.authedUser?.serviceNum < 2}
          // #7116 END
          isServiceList={this.pathOptions.isServiceList}
        />
        <ServiceRecordList
          serviceCd={serviceCd}
          isCompany={this.pathOptions.isCompany}
          serviceUsageList={serviceUsageList}
          downloadFormOK={this.openCSVExportConfirm.bind(
            this,
            MessageTemplate.BULK_EXPORT,
            null,
          )}
          isSupperUserL0={isSupperUserL0}
          isUsingNewPlan={isUsingNewPlan}
          isServiceList={this.pathOptions.isServiceList}
          serviceInfo={serviceInfo}
          recordNum={this.state.recordNum}
          getStartEndData={this.getStartEndData}
          startPosition={this.state.searchInfo.startPosition}
        />
        {!this.pathOptions.isCompany &&
          <ServiceListDialog
            show={showDialog}
            openDialog={this.onClickOpenDialog}
            closeDialog={this.closeDialog}
            cancelSelectedService={this.cancelSelectedService}
            getStartEndData={this.getStartEndData}
            recordNum={this.state.recordNum}
            startPosition={this.state.searchInfo.startPosition}
            onSelectedService={this.onSelectedService}
            // #7116 START
            onSearchServiceBtnClick = {this.handleSearchBtn}
            isAllowShowSearchMessageInServiceDialog={this.state.isAllowShowSearchMessageInServiceDialog}
            dismissMessage={this.dismissMessage}
            // #7116 END
          />}
        {this.pathOptions.isCompany &&
          <ServiceGroupDialog
            show={showGroupSelectDialog}
            openGroupSelectDialog={this.openGroupSelectDialog}
            onSelectGroup={this.onSelectGroup}
            serviceRecordSearch={this.props.serviceRecordSearch}
            isSupperUserL0={isSupperUserL0}
          />}
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onCSVExportCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onCSVExportOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { authedUser } = state.authed;
  const {
    searchInfo,
    searchResult,
    newEnterpriseCd,
    newServiceCd,
    systemUsageMonths,
  } = state.serviceRecord;
  const { serviceRecordSearch } = state.form;
  const { serviceInfo } = state.serviceRecord;
  const { enterprises } = state.enterprise;

  const initial = { ...searchInfo };
  if (!initial.enterpriseCd) {
    // #7116 START
    initial.enterpriseCdForDisplay = authedUser.enterpriseCd;
    // #7116 END
    initial.enterpriseCd = authedUser.enterpriseName;
    initial.selectedEnterprise = authedUser.enterpriseCd;
  }
  if (!initial.serviceCd) {
    initial.serviceCd = authedUser.serviceName || '';
    initial.selectedService = authedUser.serviceCd;
  }

  if (newEnterpriseCd && isObject(newEnterpriseCd)) {
    // #7116 START
    initial.enterpriseCdForDisplay = newEnterpriseCd.enterpriseCd;
    // #7116 END
    initial.enterpriseCd = newEnterpriseCd.enterpriseName || '';
    initial.selectedEnterprise = newEnterpriseCd.enterpriseCd;
  }

  if (newServiceCd && isObject(newServiceCd)) {
    initial.serviceCd = newServiceCd.serviceName;
    initial.selectedService = newServiceCd.serviceCd;
  }

  if (serviceRecordSearch && serviceRecordSearch.values) {
    initial.selectTargetMonth = serviceRecordSearch.values.selectTargetMonth;
    initial.startPosition = serviceRecordSearch.values.startPosition;
  }
  return {
    ...{ authedUser },
    ...{ searchResult },
    ...{ systemUsageMonths },
    ...{ serviceInfo },
    ...{ serviceRecordSearch },
    ...{ enterprises },
    initialValues: initial,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'serviceRecordSearch',
    enableReinitialize: true,
    touchOnChange: true,
    destroyOnUnmount: true,
  })(ServiceRecordContainer),
);
